import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { mq } from "@miro-site/design-tokens";
import * as React from "react";
import styled from "styled-components";
import Box from "./Box";
var StyledDiv = styled(Box).withConfig({
    componentId: "sc-66087f58-0"
})(_templateObject(), function(param) {
    var theme = param.theme, $on = param.$on;
    return Object.keys(theme.mediaQueries).map(function(q) {
        return $on.includes(q) && mq[q]({
            display: "none"
        });
    });
});
var Hide = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var _$on = _param.$on, $on = _$on === void 0 ? [] : _$on, children = _param.children, props = _object_without_properties(_param, [
        "$on",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(StyledDiv, _object_spread_props(_object_spread({
        ref: ref,
        $on: $on
    }, props), {
        children: children
    }));
});
Hide.displayName = "Hide";
export default Hide;
